export const StimulusResponseViewerController = function () {
	// Empty controller for now.
};
